export const MXN_ACTION_TYPE = {
    PILLS: "parentCategorytype",
    CATEGORY: "categoryType",
    VEG_NONVEG: "vegNonvegClassifier",
    UPDATE_ITEM_HANDLER: "UPDATE_ITEM_HANDLER",
    ADD_CUTOMIZE_ITEM_HANDLER: "ADD_CUTOMIZE_ITEM_HANDLER",
    UPDATE_CUTOMIZE_ITEM_HANDLER: "UPDATE_CUTOMIZE_ITEM_HANDLER",
    UPDATE_CROSS_SELL_ITEM_HANDLER: "UPDATE_CROSS_SELL_ITEM_HANDLER",
    UPDATE_CROSS_SELL_CUTOMIZE_ITEM_HANDLER: "UPDATE_CROSS_SELL_CUTOMIZE_ITEM_HANDLER",
    MENU_BACK: "MENU_BACK",
    FAB_WIDGET: "FAB_WIDGET",
    // Filter-specific action types
    HALF_CARD_CONTENT_APPLY_FILTERS: "halfCardContentApplyFilters",
    PILL_SELECTED_FILTERS_CLICK: "pillSelectedFiltersClick",
    PILL_UNSELECTED_FILTERS_CLICK: "pillUnselectedFiltersClick",
    CLEAR_FILTERS: "clearFilters",
    TOGGLE_THEME: "TOGGLE_THEME",
    BILL_PAYMENT: "BILL_PAYMENT",
};

// show veg non veg fiter widget if category matches with below keywords
export const VEG_NONVEG_FILTERS_LIST: string[] = [];

export const RECORD_PERCIEVED_TIME_EVENTS = {
    MENU_LOAD_EVENT: "menu_load_event",
    APP_START: "app_start",
    MENU_APPLY_FILTERS: "menu_apply_filters",
};

export const CROSS_SELL_DEFAULT_FREQUENCY_CAP = 5;

export const CROSS_SELL_FREQ_TTL_MS = 3 * 60 * 60 * 1000; // 3 hours
